<template>
    <section :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-[#e9eef6] tw-border-[#d1d5db]'" class="tw-border-b tw-px-6 tw-py-4 tw-flex tw-items-center tw-gap-3">
            <div :class="theme === 'dark' ? 'tw-bg-amber-500/10 tw-text-amber-400' : 'tw-bg-amber-50 tw-text-amber-600'" class="tw-p-2.5 tw-rounded-lg">
                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/></svg>
            </div>
            <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Armazenagem Total</h3>
        </div>
        <div class="tw-p-5 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4">
            <div class="tw-relative">
                <ProgressCircle :percentage="percentage" />
            </div>
            <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-center">
                <p class="tw-text-xs tw-uppercase tw-tracking-wider tw-font-semibold" :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'">Total</p>
                <p class="tw-text-2xl tw-font-bold tw-mt-1">{{ armazenadoTotal }}</p>
                <p class="tw-text-xs" :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-600'">/ {{ capacidadeTotal }} Sacas</p>
            </div>
        </div>
    </section>
</template>
<script>
import ProgressCircle from '@/components/ui/v2/ProgressCircle.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'DashboardArmazenagemTotal',
    components: {
        ProgressCircle
    },
    props: {
        percentage: {
            type: Number,
            required: true
        },
        armazenadoTotal: {
            type: Number,
            required: true
        },
        capacidadeTotal: {
            type: Number,
            required: true
        }
    },
    setup() {
        const store = useStore();
        const theme = computed(() => store.state.ui.theme);
        return { theme }
    }
}
</script>
